import {createLogger} from "../util/logger";

const console = createLogger("EventEmitter", false);

/**
 * Simple event emitter implementation
 */
export class EventEmitter {

    /**
     * @type {{[key: string]: Set<function>}}
     */
    listeners = {};


    /**
     * Attaches event listener
     * @param {string} event The event to listen to
     * @param {function} listener The callback to be executed when event is triggered
     * @returns {function(): void} A function which removes the listener when invoked
     */
    on(event, listener) {
        console.log("on", event, listener, this);

        if (!this.listeners[event]) this.listeners[event] = new Set();

        this.listeners[event].add(listener);


        return () => this.off(event, listener);
    };

    /**
     * Removes event listener from emitter if it is attached
     * @param {string} event The events name
     * @param {function}  listener The function to remove
     */
    off(event, listener) {
        console.log("off", event, listener, this);

        if (!this.listeners[event]) return;

        this.listeners[event].remove(listener);
    }

    /**
     * Triggers listeners on {event} with {...args}
     * @param {string} event The events name to trigger
     * @param {...any} args List of arguments
     */
    trigger(event, ...args) {
        console.log("trigger", event, args, this);
        if (!this.listeners[event]) return;
        this.listeners[event].forEach((callback) => {
            callback.call(null, ...args);
        });
    }

}
